import styled from 'styled-components'

export const ErrorText = styled.div`
	color: #dc2626;
	font-size: 0.875rem;
	margin-top: -0.5rem;
	margin-bottom: 1rem;
`

export const HintText = styled.div`
	color: #6c757d;
	font-size: 0.875rem;
	margin-top: -0.5rem;
	margin-bottom: 1rem;
`
